import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed, ref} from 'vue';
import Sorter from '../Sorter.vue';
import {FulltextSearchField, ValueType} from '@/api/meta/filters';
import {useFilterSort} from '@/composables/filterSort';
import useOffersStore from '@/store/offers';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterOffer',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;
const store = useOffersStore();

const {filters, save, reset, sorts, SortTypes} = useFilterSort(store, emits);

const allSearchInItems = ref<Array<{
      text: string;
      value: FulltextSearchField;
}>>([
  {
    text: 'Angebots-Nr.',
    value: {
      path: ['AngebotNr'],
      valueType: ValueType.NumberStartsWith,
    },
  },
  {
    text: 'Artikel-Nr.',
    value: {
      path: ['Positionen', 'ArtikelNr'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'Artikelbezeichnung 1',
    value: {
      path: ['Positionen', 'ArtikelBezeichnung1'],
      valueType: ValueType.StringContains,
    },
  },
  {
    text: 'Artikelbezeichnung 2',
    value: {
      path: ['Positionen', 'ArtikelBezeichnung2'],
      valueType: ValueType.StringContains,
    },
  },
]);
const sortableFields = ref([
  {
    text: 'Datum',
    value: 'Datum',
  },
]);

const form = ref<HTMLFormElement & VNodeRef | undefined>();

const fulltextSearch = computed({
  set(sWord: string) {
    const words = (sWord ?? '').split(' ').filter((w) => !!w);
    filters.value.Fulltext$Fulltext.words = words;
  },
  get(): string {
    const words = filters.value.Fulltext$Fulltext.words;

    return words?.join(' ') || '';
  },
});
const erledigt = computed({
  set(val: 'J' | 'N' | null | undefined) {
    filters.value.Erledigt = val ?? undefined;
  },
  get(): 'J' | 'N' | undefined {
    return filters.value.Erledigt;
  },
});

__expose({
  Sorter,
  allSearchInItems,
  sortableFields,
  form,
  fulltextSearch,
  erledigt,
  save, reset,
  sorts: sorts.value,
  SortTypes,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-filter")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(" Filter "),
          _createVNode(_component_v_icon, {
            onClick: _unref(save),
            class: "ml-auto",
            end: "",
            color: "grey"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "px-3 py-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(Sorter, {
                modelValue: _unref(sorts),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sorts) ? (sorts).value = $event : null)),
                sortableFields: sortableFields.value,
                SortTypes: _unref(SortTypes)
              }, null, 8, ["modelValue", "sortableFields", "SortTypes"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_form, { ref: form.value }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: fulltextSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fulltextSearch).value = $event)),
                variant: "outlined",
                "hide-details": "",
                placeholder: "Freitextsuche",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (fulltextSearch.value = ''))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_select, {
                variant: "plain",
                messages: "",
                density: "compact",
                items: allSearchInItems.value,
                multiple: "",
                "item-title": "text",
                "item-value": "value",
                modelValue: _unref(filters).Fulltext$Fulltext.fields,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).Fulltext$Fulltext.fields) = $event))
              }, {
                selection: _withCtx(({ item }) => [
                  _createVNode(_component_v_chip, {
                    variant: "outlined",
                    class: "black--color",
                    color: "grey",
                    size: "x-small"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["items", "modelValue"]),
              _createVNode(_component_v_select, {
                modelValue: erledigt.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((erledigt).value = $event)),
                "item-title": "text",
                "item-value": "value",
                items: [{value: 'J', text: 'Ja'}, {value: 'N', text: 'Nein'}],
                label: "Erledigt",
                clearable: ""
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }, 512)
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "grey",
            class: "flex-1",
            variant: "outlined",
            size: "large",
            onClick: _unref(reset)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Zurücksetzen")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            class: "flex-1 btn-navigator-primary",
            size: "large",
            onClick: _unref(save)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Speichern")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})